import React from 'react';
import PublicAppointmentFrontDeskList from './components/PublicAppointment';

const PublicAppointmentFrontDesk = () => <PublicAppointmentFrontDeskList />;

export default PublicAppointmentFrontDesk;
